
import { Component,Prop, BaseMixins } from '@/lib';
@Component({name:"icons"})
export default class FullScreen extends BaseMixins {
    name:string= 'Icons';
    @Prop({type:String,required: true}) type:string;
    @Prop({type:String,required: true,default:'#5c6b77'}) color:string;
    @Prop({type:Number,required: true,default:16}) size:number;

    get styles() {
      return {
        fontSize: `${this.size}px`,
        color: this.color
      }
    }
}
